import clsx from 'clsx'
import type { FC } from 'react'
import styles from './PinMark.module.css'
import { useTipToggle } from './tip-toggle'

export const PIN_MARK_TEXT = 'Pinned by the moderators'

/**
 * The pin: the one mark of a pinned comment (a moderator's pick, or an editor's featured pick
 * from before 2026-10-29, which reads as pinned) — beside the author's name in the widget and
 * beside the quoted name on the collapsed surfaces (the rail card, the mobile bar). A solid pin
 * with a small overlay saying what it is, on hover, keyboard focus or a tap (Guillaume,
 * 2026-10-29: "thicker", "an overlay text to explain what it is").
 */
const PinMark: FC<{ className?: string }> = ({ className }) => {
  const tip = useTipToggle()
  return (
    <button
      type="button"
      className={clsx(styles.wrap, tip.open && styles.wrapOpen, className)}
      aria-label={PIN_MARK_TEXT}
      onClick={tip.onClick}
      onBlur={tip.onBlur}
    >
      <svg className={styles.pin} viewBox="0 0 24 24" aria-hidden="true">
        <path d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z" />
      </svg>
      <span className={styles.tip} role="tooltip" aria-hidden="true">
        {PIN_MARK_TEXT}
      </span>
    </button>
  )
}

export default PinMark
